/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Sunday, August 14th 2022, 8:33:09 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { RecycleBinItem, ReversionVersion } from "lib/schemas";
import { useAPIMutation, APISERVICEPATHS, useAPIFetchList } from "lib/api";

export const useRestoreOSRevision = <T>() => {
  const { patchData, ...otherProperties } = useAPIMutation<ReversionVersion>({
    apiServicePath: APISERVICEPATHS.restoreVersion,
  });

  const restoreVersion = (versionId: number, onRestore: (item: T) => void) => {
    patchData({
      apiPathParams: [versionId],
      setValidAPIResponse: (restoredVersion: ReversionVersion) => {
        const restoredData = JSON.parse(restoredVersion.serialized_data)[0];
        onRestore({ ...restoredData.fields, id: restoredData.pk });
      },
    });
  };

  return { restoreVersion, ...otherProperties };
};

export const useListRecycleBinItems = () => {
  const {
    fetchList,
    items: recycleBinItems,
    ...otherProperties
  } = useAPIFetchList<RecycleBinItem[]>({
    apiServicePath: APISERVICEPATHS.recycleBin,
    makeRequestOnInitialMount: false,
  });

  return { fetchList, recycleBinItems, ...otherProperties };
};
